import { cn } from "@/lib/utils";
import { site } from "@/content/site";

interface ContactMapProps {
  className?: string;
  heightClass?: string;
  premium?: boolean;
}

export function ContactMap({
  className,
  heightClass = "h-48 md:h-56",
  premium = false,
}: ContactMapProps) {
  return (
    <div
      className={cn(
        "overflow-hidden shadow-sm",
        premium
          ? "rounded-2xl border border-[var(--contact-border)] bg-[var(--contact-surface)]"
          : "rounded-xl border border-border bg-surface-elevated",
        heightClass,
        className
      )}
    >
      <iframe
        src={site.mapEmbedUrl}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Office location"
      />
    </div>
  );
}
